import React, { FC } from 'react';
import styled from 'styled-components';

const StyledVideo = styled.video`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: -100;
  object-fit: cover
`;

export interface BackgroundVideoProps {
  src: string;
  type: string;
  id?: string;
}

const BackgroundVideo: FC<BackgroundVideoProps> = ({ src, type, id }: BackgroundVideoProps) => (
  <StyledVideo autoPlay muted loop playsInline data-object-fit="cover" id={id}>
    <source src={src} type={type} />
  </StyledVideo>
);

export default BackgroundVideo;
